import React from 'react'
import {JSONFetcher} from 'shared'
import ContentHeader from './content_header'
import {BasicInfo, Numbers, ManageBox, DonationList, Description, News, Forwardings, Sharing, Sticky} from 'fepp'

export class Page extends React.Component {
  state = {}

  componentDidMount() {
    JSONFetcher.load({
      url:     this.props.apiUrl,
      success: fundraisingEvent => this.setState({fundraisingEvent})
    })
  }

  render() {
    if (!this.state.fundraisingEvent) return null

    const crowdFunDayEvent = 33188

    return <div>
      <ContentHeader fundraisingEvent={this.state.fundraisingEvent} {...this.props} />
      <div className="fundraising-events-show fundraising-events-controller">
        <div className="content-wrapper">
          <Sticky fundraisingEvent={this.state.fundraisingEvent} />
          <BasicInfo fundraisingEvent={this.state.fundraisingEvent} {...this.props} />
          <Numbers   fundraisingEvent={this.state.fundraisingEvent} {...this.props} />
          <ManageBox fundraisingEvent={this.state.fundraisingEvent} {...this.props} />
          {this.state.fundraisingEvent.id == crowdFunDayEvent && <DonationList fundraisingEvent={this.state.fundraisingEvent} facets="&facets=company_donation:false" />}
          {this.state.fundraisingEvent.id == crowdFunDayEvent && <DonationList fundraisingEvent={this.state.fundraisingEvent} headline="Firmenspenden" facets="&facets=company_donation:true" per_page="4" />}
          {this.state.fundraisingEvent.id != crowdFunDayEvent && <DonationList fundraisingEvent={this.state.fundraisingEvent}  />}
          <Description fundraisingEvent={this.state.fundraisingEvent} />
          <News fundraisingEvent={this.state.fundraisingEvent} />
          <Forwardings fundraisingEvent={this.state.fundraisingEvent} />
          <Sharing fundraisingEvent={this.state.fundraisingEvent} />
        </div>
      </div>
    </div>
  }
}
